// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__2Urbn","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__xhaTL"};